import http from 'plugins/axios';

export default {
  getUrlList(data) {
    return http.get({
      url: `/la/admin/app/line/url/list`,
      data
    })
  },


  delOne(id) {
    return http.post({
      url: `/la/admin/app/line/url/del?id=${id}`,
    });
  },
  addOne(data) {
    return http.post({
      url: '/la/admin/app/line/url/add',
      data,
    });
  },
  updateUrl(data) {
    return http.post({
      url: '/la/admin/app/line/url/update',
      data,
    });
  },
  // updateCode(data) {
  //   return http.post({
  //     url: '/la/admin/countryCode/update',
  //     data,
  //   });
  // },
};
